import {
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";
import { sendPassword } from "../../../service/user-detail-service";
import Loading from "../../loader/loader";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { getUserRoleName } from "../../azureLogin/authUtility";

const UserDetail = ({
  allUsersObject,
  id,
  profileloading,
  kycDetail,
  dateFormat,
  setEidUpdateModal,
}) => {
  const [userId, setUserId] = useState(id);
  const [blockedStatus, setBlockedStatus] = useState(false);

  const roleName = getUserRoleName()

  let isVerifier =
    roleName === "CustomerServiceAgent" || false;

  let isAdmin = roleName == "Admin" || false;

  let isSuperAdmin = roleName == "SuperAdmin" || false;

  useEffect(() => {
    if (id) {
      setUserId(id);
    }
  }, [id]);
  useEffect(() => {
    if (dateFormat != undefined || dateFormat != null) {
      let temp = moment(dateFormat).format("DD/MM/YYYY hh:mm:ss A");
      let currentDate = moment().format("DD/MM/YYYY hh:mm:ss A");
      if (temp > currentDate) {
        return setBlockedStatus(true);
      } else if (temp < currentDate || temp == null) {
        return setBlockedStatus(false);
      }
    }
  }, [dateFormat]);

  const [showSendPasswordModal, setShowSendPasswordModal] = useState(false);
  const [buttonLoading, setButtonLoading] = useState();

  const resetPassword = () => {
    setButtonLoading(true);
    sendPassword(userId)
      .then((res) => {
        console.log(res);
        setButtonLoading(false);
        setShowSendPasswordModal(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "Password has been sent successfully!"
        );
      })
      .catch((err) => {
        console.log(err);
        setButtonLoading(false);
        setShowSendPasswordModal(false);
      });
  };

  function PasswordSuccessfulModal4(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="common-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure, you want to send the password?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={props.onHide}>
            No
          </Button>
          <Button
            variant="primary"
            onClick={props.handleClick}
            color="primary"
            disabled={buttonLoading}
          >
            {" "}
            {buttonLoading ? (
              <Loading color="white" width="15px" height="15px" />
            ) : (
              "Yes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const [showKycModal, setShowKycModal] = useState(false);

  function MyVerticallyCenteredModal3(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="card-wrapper" style={{ display: "flex" }}>
            <Col lg="6">
              <Card>
                {(kycDetail && kycDetail.frontEIDImageURL === "") ||
                (kycDetail && kycDetail.frontEIDImageURL === null) ? (
                  <div style={{ padding: "8px" }}>Front Image not Found</div>
                ) : (
                  <CardImg
                    alt="..."
                    src={kycDetail && kycDetail.frontEIDImageURL}
                    top
                  />
                )}
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                {(kycDetail && kycDetail.backEIDImageURL === "") ||
                (kycDetail && kycDetail.backEIDImageURL === null) ? (
                  <div style={{ padding: "8px" }}>Back Image not Found</div>
                ) : (
                  <CardImg
                    alt="..."
                    src={kycDetail && kycDetail.backEIDImageURL}
                    top
                  />
                )}
              </Card>
            </Col>
          </Row>
          <Row className="card-wrapper" style={{ display: "flex" }}>
            <Col lg="6">
              <Card>
                {(kycDetail && kycDetail.selfieImageURL === "") ||
                (kycDetail && kycDetail.selfieImageURL === null) ? (
                  <div style={{ padding: "8px" }}>Selfie Image not Found</div>
                ) : (
                  <CardImg
                    alt="..."
                    src={kycDetail && kycDetail.selfieImageURL}
                    top
                  />
                )}
              </Card>
            </Col>

            <Col lg="6">
              <Card>
                {(kycDetail && kycDetail.passportImageURL === "") ||
                (kycDetail && kycDetail.passportImageURL === null) ? (
                  <div style={{ padding: "8px" }}>Passport Image not Found</div>
                ) : (
                  <CardImg
                    alt="..."
                    src={kycDetail && kycDetail.passportImageURL}
                    top
                  />
                )}
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={props.onHide}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  var first =
    allUsersObject &&
    allUsersObject.cardNumber &&
    allUsersObject.cardNumber.toString().substring(0, 6);
  var str1 =
    allUsersObject &&
    allUsersObject.cardNumber &&
    allUsersObject.cardNumber.toString().substring(6, 12);
  var second = str1 && str1.replace(str1, "******");
  var third =
    allUsersObject &&
    allUsersObject.cardNumber &&
    allUsersObject.cardNumber.toString().substring(12, 16);

  return (
    <>
      <Card style={{ marginBottom: "10px", height: "98%" }}>
        <CardBody>
          <CardTitle className="mb-3 user-verification-header" tag="h1">
            User Details
          </CardTitle>
          {profileloading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loading style={{ width: "10px", height: "10px" }} />
            </div>
          ) : (
            <>
              <Row
                className="card-wrapper personal"
                style={{ paddingBottom: 15 }}
              >
                <Col lg="5" style={{ paddingRight: "0px" }}>
                  <CardBody style={{ padding: "0px" }}>
                    <CardTitle className="mb-3 user-subheader" tag="h2">
                      Personal
                    </CardTitle>
                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        Nationality
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-6 col-md-6">
                        {" "}
                        {allUsersObject.nationality}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        Date Of Birth
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-6 col-md-6">
                        {" "}
                        {moment(allUsersObject.birthdate || null).format(
                          "DD-MM-YY"
                        ) !== "Invalid date"
                          ? moment(allUsersObject.birthdate || null).format(
                              "DD-MM-YY"
                            )
                          : null || null}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ paddingLeft: "0px" }}
                      >
                        Gender
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-6 col-md-6">
                        {" "}
                        {allUsersObject.cardGender
                          ? allUsersObject.cardGender
                          : ""}
                      </label>
                    </div>

                    <Button
                      color="primary"
                      onClick={() => setShowSendPasswordModal(true)}
                      style={{ marginTop: "10px" }}
                    >
                      Send Password
                    </Button>
                  </CardBody>
                </Col>
                <Col lg="7" style={{ paddingRight: "0px" }}>
                  <CardBody style={{ padding: "0px" }}>
                    <CardTitle className="mb-3 user-subheader" tag="h2">
                      Registration
                    </CardTitle>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-4"
                        style={{ paddingLeft: "0px" }}
                      >
                        Date
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-5 col-md-6">
                        {" "}
                        {moment(allUsersObject.registrationDate || null).format(
                          "DD-MM-YY"
                        ) !== "Invalid date"
                          ? moment(
                              allUsersObject.registrationDate || null
                            ).format("DD-MM-YY")
                          : null || null}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        Card Number
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-6 col-md-6">
                        {" "}
                        {first}
                        {second}
                        {third}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        Mobile Number
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-6 col-md-6">
                        {" "}
                        {allUsersObject.phoneNumber}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        Passport Number
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-6 col-md-6">
                        {" "}
                        {allUsersObject.passportNumber}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        EID Number
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className=" col-lg-6 col-md-6">
                        {" "}
                        {allUsersObject.emiratesId}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        Email ID
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label
                        className=" col-lg-6 col-md-6"
                        style={{ paddingRight: "0px" }}
                      >
                        {" "}
                        {allUsersObject && allUsersObject.email}
                      </label>
                    </div>

                    <div className="row form-group al-center">
                      <label
                        className="form-control-label col-lg-5 col-md-5"
                        style={{ padding: "0px" }}
                      >
                        KYC{" "}
                      </label>
                      <label className="form-control-label col-lg-0.5 col-md-0.5">
                        :
                      </label>
                      <label className="form-control-label col-lg-6 col-md-6">
                        {" "}
                        {allUsersObject && allUsersObject.isKYCUploaded
                          ? " Uploaded"
                          : "Not Uploaded"}
                      </label>
                    </div>
                    {allUsersObject && allUsersObject.isKYCUploaded ? (
                      <>
                        <Button
                          color="primary"
                          onClick={() => {
                            setShowKycModal(true);
                          }}
                          style={{ marginTop: "10px" }}
                        >
                          View KYC
                        </Button>
                      </>
                    ) : null}
                    {isVerifier || isAdmin || isSuperAdmin ? (
                      <Button
                        color="primary"
                        onClick={() => {
                          setEidUpdateModal(true);
                        }}
                        style={{ marginTop: "10px" }}
                      >
                        Update EID number
                      </Button>
                    ) : (
                      ""
                    )}
                  </CardBody>
                </Col>
              </Row>
              <Row>
                {allUsersObject.appStatus == 2 && (
                  <div className="row form-group al-center">
                    <label
                      className="form-control-label col-lg-4 col-md-4"
                      style={{ maxWidth: "177px" }}
                    >
                      App Blocked Reason
                    </label>
                    <label className="form-control-label col-lg-0.5 col-md-0.5">
                      :
                    </label>
                    <label
                      style={{ paddingLeft: "15px" }}
                      className=" col-lg-16 col-md-16"
                    >
                      {allUsersObject.isBlocked &&
                        allUsersObject.isLocked &&
                        `${allUsersObject.blockedType} `}

                      {allUsersObject.blockedReason &&
                        `- ${allUsersObject.blockedReason}`}

                      {allUsersObject.isBlocked === false &&
                        allUsersObject.isLocked &&
                        `Locked`}
                    </label>
                  </div>
                )}
              </Row>
              <div className="row form-group al-center col-lg-24 col-md-24 col-xl-12">
                <label
                  className="form-control-label col-lg-4 col-md-4"
                  style={{ paddingLeft: "0px", maxWidth: "177px" }}
                >
                  ATM PIN Feature
                </label>
                <label className="form-control-label col-lg-0.5 col-md-0.5">
                  :
                </label>
                <label className=" col-lg-6 col-md-6">
                  {blockedStatus
                    ? `Blocked till ${moment(dateFormat).format(
                        "DD/MM/YYYY hh:mm:ss A"
                      )}`
                    : "Active"}
                </label>
              </div>
              {allUsersObject.referralCode && (
                <div className="row form-group al-center col-lg-24 col-md-24 col-xl-12">
                  <label
                    className="form-control-label col-lg-4 col-md-4"
                    style={{ paddingLeft: "0px", maxWidth: "177px" }}
                  >
                    Referral Code
                  </label>
                  <label className="form-control-label col-lg-0.5 col-md-0.5">
                    :
                  </label>
                  <label className=" col-lg-6 col-md-6">
                    {`${allUsersObject.referralCode}`}
                  </label>
                </div>
              )}
            </>
          )}
        </CardBody>
      </Card>
      <PasswordSuccessfulModal4
        onHide={() => setShowSendPasswordModal(false)}
        show={showSendPasswordModal}
        handleClick={() => {
          resetPassword();
        }}
      />
      <MyVerticallyCenteredModal3
        show={showKycModal}
        onHide={() => setShowKycModal(false)}
      />
    </>
  );
};

export default UserDetail;
